import { Component } from '@angular/core';
import { HeaderComponent } from './header/header.component';
import { RouterOutlet } from '@angular/router';
import { FooterBarComponent } from '@bpifrance/propulsion';
import { BreadcrumbComponent } from '../../shared/components/breadcrumb/breadcrumb.component';
@Component({
  selector: 'app-layout',
  imports: [
    RouterOutlet,
    HeaderComponent,
    FooterBarComponent,
    BreadcrumbComponent,
  ],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss',
})
export class LayoutComponent {
  footerBarLinks = [
    { label: 'Mentions légales', url: '/mentions-legales' },
    { label: 'CGU', url: '/cgu' },
    { label: "Besoin d'aide ?", url: '/aide' },
    { label: 'Protections des données', url: '/protection-données' },
    { label: 'Plan du site', url: '/plan-site' },
    { label: 'Gestion des cookies', url: '/cookies' },
  ];
}
